import { DateValueI, FilterOptionI } from '@/utils/filterDrawers'

export const getStartOfDay = (date: Date) => {
  const copy = new Date(date)
  copy.setUTCHours(0, 0, 0, 0)
  return copy.toISOString()
}

export const getEndOfDay = (date: Date) => {
  const copy = new Date(date)
  copy.setUTCHours(23, 59, 59, 999)
  return copy.toISOString()
}

/**
 * Rehydrates the custom-range date pickers from a saved Created At value.
 * The saved UTC boundary's calendar day is rebuilt as a local date pinned to
 * noon, so timezone offsets can't move the displayed day. (The legacy
 * DateSelect shifted to the current local hour instead, which showed the
 * wrong day when the local hour plus the UTC offset crossed midnight.)
 */
export const getCustomDates = (
  option: FilterOptionI<number | DateValueI> | null | undefined
) => {
  const toLocalSameDay = (iso: string) => {
    const utc = new Date(iso)
    return new Date(
      utc.getUTCFullYear(),
      utc.getUTCMonth(),
      utc.getUTCDate(),
      12
    )
  }
  const customValue = option?.value as DateValueI | undefined
  const now = new Date()
  return {
    startDate: customValue?.gte ? toLocalSameDay(customValue.gte) : now,
    endDate: customValue?.lte ? toLocalSameDay(customValue.lte) : now,
  }
}
